import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface HealerFeedbackState {
  feedbackForm: {
    technicalIssues: string;
    sessionFeedback?: string;
    error?: string;
    file?: File;
  };
}

export const buildHealerFeedbackInitialState = (): HealerFeedbackState => ({
  feedbackForm: { technicalIssues: '', error: undefined, file: undefined },
});

export const healerFeedbackSlice = createSlice({
  name: 'healerFeedback',
  initialState: buildHealerFeedbackInitialState(),
  reducers: {
    updateTechnicalIssuesFeedbackFieldForm: (state, { payload }: PayloadAction<string>) => {
      state.feedbackForm.technicalIssues = payload;
    },

    updateSessionFeedbackFieldForm: (state, { payload }: PayloadAction<string>) => {
      state.feedbackForm.sessionFeedback = payload;
    },
    updateErrorFeedbackForm: (state, { payload }: PayloadAction<string | undefined>) => {
      state.feedbackForm.error = payload;
    },
    updateFileFeedbackForm: (state, { payload }: PayloadAction<File | undefined>) => {
      state.feedbackForm.file = payload;
    },
    resetFeedbackForm: (state) => {
      state.feedbackForm = {
        technicalIssues: '',
        sessionFeedback: undefined,
        error: undefined,
        file: undefined,
      };
    },
    removeFileFeedbackForm: (state) => {
      state.feedbackForm.file = undefined;
    },
  },
});

export const {
  updateTechnicalIssuesFeedbackFieldForm,
  updateSessionFeedbackFieldForm,
  updateErrorFeedbackForm,
  updateFileFeedbackForm,
  resetFeedbackForm,
  removeFileFeedbackForm,
} = healerFeedbackSlice.actions;

export default healerFeedbackSlice.reducer;
